import { type PropsWithChildren } from 'react';

import { _textStyleCSS as textStyleCSS } from '@dynatrace/strato-components/styles';

/**
 * The footer inside the Terminology Overlay. Add links to further related documentation.
 * @public
 */
export const Footer = ({ children }: PropsWithChildren) => (
  <footer className={textStyleCSS({ textStyle: 'base' })}>{children}</footer>
);

Footer.displayName = 'TerminologyOverlay.Footer';
